import { setRole, setToken } from '@/utils/auth';
import {
  SignInRequest,
  SignInResponse,
  SignUpRequest,
  SignUpResponse,
} from '@/types/AuthType';
import { rtkApi } from '../rtkApi';

export const authApi = rtkApi.injectEndpoints({
  endpoints: (builder) => ({
    signIn: builder.mutation<SignInResponse, SignInRequest>({
      query: (request) => ({
        url: '/auth/signin',
        method: 'POST',
        data: request,
      }),
      transformResponse: (response: SignInResponse) => {
        if (response.token) {
          setToken(response.token);
          setRole(response.role);
          // Store user ID in localStorage for later use
          if (response.user?._id) {
            localStorage.setItem('user_id', response.user._id);
          }
          // Remove navigation logic - let the component handle it
        }
        return response;
      },
      invalidatesTags: ['User'],
    }),
    signUp: builder.mutation<SignUpResponse, SignUpRequest>({
      query: (request) => ({
        url: '/auth/signup',
        method: 'POST',
        data: request,
      }),
      transformResponse: (response: SignUpResponse) => {
        if (response.token) {
          setToken(response.token);
          setRole(response.role);
          window.location.href = '/main';
        }
        return response;
      },
    }),
    verifySignIn: builder.mutation<SignInResponse, string>({
      query: (uid: string) => ({
        url: '/auth/signin/verify',
        method: 'post',
        data: { uid },
      }),
      transformResponse: (response: SignInResponse) => {
        if (response.token) {
          setToken(response.token);
        }
        return response;
      },
      invalidatesTags: ['User'],
    }),
    updateSecurity: builder.mutation<void, boolean>({
      query: (status: boolean) => ({
        url: '/auth/security',
        method: 'put',
        data: { status },
      }),
      invalidatesTags: ['User'],
    }),
    verifySecurity: builder.mutation<void, string>({
      query: (uid: string) => ({
        url: '/auth/security/verify',
        method: 'post',
        data: { uid },
      }),
      invalidatesTags: ['User'],
    }),
  }),
});

export const {
  useSignInMutation,
  useSignUpMutation,
  useVerifySecurityMutation,
  useUpdateSecurityMutation,
  useVerifySignInMutation,
} = authApi;
